import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import ModalEncuestaSatisfaccion from "./Pagos/ModalEncuestaSatisfaccion";
import useMatricula from "../hooks/useMatricula";
import DocumentosMatricula from "./DocumentosMatricula/DocumentosMatricula";
import { listado_encuesta_listasHabilitadas } from "../services/procesoMatricula/procesoMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { COURSERA_GMODALIDAD } from "../config/constantes";

const Confirmacion = () => {
  //Cambio de idioma de etiquetas

  const { listadoEtiquetas } = useAuth();
  const { obtenerDatosEstudiante } = useMatricula();
  const { setLoading } = useProcesoMatricula();
  const [etiquetas, setEtiquetas] = useState({});
  const [show, setShow] = useState(false);
  const [listEncuestasForm, setListEncuestasForm] = useState([]);

  const { gcondicion, gencuesta,gmodalidad } = obtenerDatosEstudiante || {};

  useEffect(() => {
    let listadoFormularioEncuesta = async () => {
      try {
        setLoading(true);

        let forumlarios = await listado_encuesta_listasHabilitadas(
          obtenerDatosEstudiante
        );

        setListEncuestasForm(forumlarios);
        setShow(true);
      } catch (e) {
      } finally {
       
      }
    };
     
    if (gencuesta !== 1) {
      listadoFormularioEncuesta();
    } else {
      setShow(false);

      if (obtenerDatosEstudiante.length === 0) {
        setLoading(true);
      } else {
        setLoading(false);
      }
    }
  }, [obtenerDatosEstudiante]);

 

  useEffect(() => {
     
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        confirmacion_msj_matriculado: obtenerLabelEtiqueta(
          "lbl_confirmacion_msj_matriculado",
          listadoEtiquetas
        ),
        confirmacion_msj_confirmado: obtenerLabelEtiqueta(
          "lbl_confirmacion_msj_confirmado",
          listadoEtiquetas
        ),
        confirmacion_constancia_matricula: obtenerLabelEtiqueta(
          "lbl_confirmacion_constancia_matricula",
          listadoEtiquetas
        ),
        confirmacion_cronograma_pago: obtenerLabelEtiqueta(
          "lbl_confirmacion_cronograma_pago",
          listadoEtiquetas
        ),
        global_horario: obtenerLabelEtiqueta(
          "lbl_global_horario",
          listadoEtiquetas
        ),
        confirmacion_volver_inicio: obtenerLabelEtiqueta(
          "lbl_confirmacion_volver_inicio",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {
    confirmacion_msj_matriculado,
    confirmacion_msj_confirmado,
    confirmacion_constancia_matricula,
    confirmacion_cronograma_pago,
    global_horario,
    confirmacion_volver_inicio,
  } = etiquetas;

  let SPLIT_COURSERA_GMODALIDAD = String(COURSERA_GMODALIDAD)
  .split("|");

  return (

    
    <>
      <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
        <div className="card shadow-sm">
          <div className="card-body">
            <fieldset>
              <div
                className="form-body va-middle"
                style={{ minHeight: "49vh" }}
              >
                <div className="text-center ">
                   
                  <DocumentosMatricula sinTitulo={false} />

                  {SPLIT_COURSERA_GMODALIDAD.includes(String(gmodalidad))? (
                     <div className="mb-3 d-flex justify-content-between align-items-center">
                     <p className="fs-15 text-start mb-0 me-3">
                       Continúa fortaleciendo tus habilidades en COURSERA.
                       Pre-inscríbete al uso de una licencia aquí:
                     </p>
                     <a
                       href="https://forms.gle/nr5U6WfQw352gAs89"
                       target="_blank"
                     >
                       {" "}
                       <img
                         className
                         style={{ width: 150, height: "auto" }}
                         src="data:image/svg+xml;base64,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"
                       />
                     </a>
                   </div>
                  ): (<></>)}
                 

                  <Link to="/" className="d-none d-md-block d-lg-block ">
                    {confirmacion_volver_inicio}
                  </Link>
                </div>
              </div>

              <Link
                to="/"
                className="btn btn-primary w-100 fw-regular d-block  d-md-none d-lg-none"
              >
                {confirmacion_volver_inicio}
              </Link>
            </fieldset>
          </div>
        </div>
      </div>

      {listEncuestasForm.map((encuestas, index) => {
        return (
          <ModalEncuestaSatisfaccion
            show={show}
            handleClose={handleClose}
            encuestas={encuestas}
            key={index}
          />
        );
      })}
      <button
        type="button"
        className="btn btn-outline-info rounded-3 mt-3 p-1 px-3 fs-sm"
        data-bs-toggle="modal"
        data-bs-target="#errorCurso"
        style={{ display: "none" }}
        id="errorAsignatura"
      ></button>
    </>
  );
};

export default Confirmacion;
